import styled from '@emotion/styled';
import { Divider } from 'antd';
import { useTranslate } from '@tolgee/react';
import BubbleMessage from 'components/Dialogue/components/Message/BubbleMessage';
import { capitalize } from 'lodash-es';
import { memo } from 'react';

export interface NonsupportedMessageV2Props {
  dataSource: Conversation.Message;
}

const Bubble = styled(BubbleMessage)`
  padding: 0;
`;
const ContentUp = styled.div`
  padding: 8px 12px 0 12px;
`;
const ContentDown = styled(ContentUp)`
  padding: 0 12px 8px 12px;
  color: #84868c;
`;
const BubbleDivider = styled(Divider)`
  margin: 4px 0;
`;
const NonsupportedMessageV2 = (props: NonsupportedMessageV2Props) => {
  const { dataSource } = props;
  const { t } = useTranslate();

  return (
    <Bubble>
      <ContentUp>[{t(`messageType.${dataSource.messageType}`)}]</ContentUp>
      <BubbleDivider />
      <ContentDown>
        {t('ViewsChat.nonsupported.label.of.platform', {
          platform: capitalize(dataSource.channel),
        })}
      </ContentDown>
    </Bubble>
  );
};
export default memo(NonsupportedMessageV2);
